import styled from "styled-components";
import { VideoPlayer } from "@sonder/ui/source/styled/fragments/VideoPlayer";
import { sizes } from "@sonder/ui/source/styled/theme";

interface VideoPlayerSlideProps {
  height?: string;
}

export const VideoPlayerSlide = styled.div<VideoPlayerSlideProps>`
  display: block;
  flex: 0 0 auto;
  position: relative;

  ${VideoPlayer} {
    height: ${props => props.height || sizes.imageHeightDefault};
  }
`;
